import type { LocalBackup } from './local-backup';
export interface BackupSectionSize { label:string; bytes:number; count:number }
export interface BackupSize { totalBytes:number; sections:BackupSectionSize[] }
const encoder=new TextEncoder();
const bytes=(value:unknown)=>encoder.encode(JSON.stringify(value)).byteLength;
function localCategory(key:string):string {
  if(key==='yumnote.recipes.v1')return 'Рецепты';
  if(key==='yumnote.lists.v1')return 'Списки и блюда';
  if(key.startsWith('yumnote.activity.v1.'))return 'Активность';
  if(key==='yumnote.weight-history.v1')return 'История веса';
  if(key==='yumnote.userFoods.v1')return 'Свои продукты';
  if(key==='yumnote.assistant.prototype.v3')return 'Профиль и история ассистента';
  return 'Цели и настройки';
}
function storeCategory(name:string):string {
  if(name==='meals' || name==='meal_items')return 'Дневник питания и расчёты';
  if(name==='water_entries')return 'Вода';
  if(name==='sync_operations')return 'История операций и повторные снимки';
  if(name==='reports')return 'Сохранённые отчёты';
  return 'Другие данные';
}
/** Section sizes are approximate JSON contributions; total is the exact UTF-8 file size. */
export function measureBackup(backup:LocalBackup):BackupSize {
  const grouped=new Map<string,BackupSectionSize>();
  function add(label:string, value:unknown, count:number) {
    const previous=grouped.get(label) ?? {label,bytes:0,count:0};
    previous.bytes+=bytes(value);previous.count+=count;grouped.set(label,previous);
  }
  for(const [key,value] of Object.entries(backup.localStorage)) add(localCategory(key),{[key]:value},1);
  for(const stores of Object.values(backup.databases)) for(const [name,items] of Object.entries(stores)) add(storeCategory(name),items,items.length);
  return {totalBytes:bytes(backup),sections:[...grouped.values()].filter(x=>x.count>0).sort((a,b)=>b.bytes-a.bytes)};
}
export function formatBytes(size:number):string {
  if(size<1000)return `${size} Б`;
  if(size<1_000_000)return `${(size/1000).toLocaleString('ru-RU',{maximumFractionDigits:1})} КБ`;
  return `${(size/1_000_000).toLocaleString('ru-RU',{maximumFractionDigits:2})} МБ`;
}
